import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, FlaskConical } from "lucide-react";
import { toast } from "sonner";
import SpideyLogo from "@/components/SpideyLogo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TestPayment() {
    const [loading, setLoading] = useState(false);

    const pay = async () => {
        try {
            setLoading(true);
            const res = await fetch(`${API}/payments/checkout`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    lookup_key: "test-1eur",
                    quantity: 1,
                    origin_url: window.location.origin,
                    size: "",
                }),
            });
            const data = await res.json();
            if (!data.checkout_url) throw new Error(data.detail || "Erreur");
            window.location.href = data.checkout_url;
        } catch (e) {
            toast.error("Impossible de démarrer le test de paiement.");
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-spidey-bg flex flex-col" data-testid="test-payment-page">
            <header className="max-w-3xl w-full mx-auto px-5 pt-8">
                <Link to="/">
                    <SpideyLogo />
                </Link>
            </header>
            <main className="flex-1 flex items-center justify-center px-5 py-16">
                <div className="w-full max-w-md bg-spidey-card border border-zinc-800 rounded-3xl p-10 text-center">
                    <FlaskConical size={44} className="mx-auto text-spidey-red" />
                    <h1 className="mt-5 font-display uppercase text-3xl text-white">Test de paiement</h1>
                    <p className="mt-3 text-sm text-zinc-400 leading-relaxed">
                        Page cachée — invisible pour tes clients. Paie 1,00 € avec ta vraie
                        carte pour vérifier que les paiements réels fonctionnent, puis
                        rembourse depuis ton dashboard Stripe (Paiements → le paiement →
                        Rembourser). Stripe conserve environ 0,30 € de frais sur un remboursement.
                    </p>
                    <button
                        onClick={pay}
                        disabled={loading}
                        className="mt-8 w-full flex items-center justify-center gap-2 bg-spidey-red hover:bg-spidey-neon disabled:opacity-70 text-white font-bold uppercase tracking-wider text-sm py-4 rounded-full transition-all hover:shadow-[0_0_30px_rgba(230,0,38,0.5)]"
                        data-testid="test-pay-1eur-button"
                    >
                        {loading ? (
                            <>
                                <Loader2 size={16} className="animate-spin" />
                                Redirection vers le paiement...
                            </>
                        ) : (
                            "Payer 1,00 € — test"
                        )}
                    </button>
                    <Link to="/ventes" className="mt-5 inline-block text-xs text-zinc-600 hover:text-spidey-neon transition-colors">
                        Voir le suivi des ventes →
                    </Link>
                </div>
            </main>
        </div>
    );
}
